/**
 * Created by zhengyf on 2017.11.23.
 */

;(function () {

    SelfResultCtrl.$inject = ['$filter', 'request', '$q', '$timeout', '$scope', 'prodOverviewConfig', 'noResultProdConfig', 'inqExposureConfig', 'inqFbConfig'];
    angular
        .module('DSSXAPP')
        .component('selfResult', {
            template:'<div class="data-admin-component data-admin-self-result"><div class="dia-common-title util-clearfix"><h3 class="util-left"><span>业务概览</span></h3><div class="util-right dia-right-tip"><span><span class="dia-icon-about"></span> <a href="javascript:;">名词解释和常见问题</a> <span class="dia-icon-hot"></span></span></div></div><div class="sr-module-wrapper"><div class="sr-top-wrap"><div class="sr-stats util-clearfix"><div class="sr-stats-left"><div><div class="common-stats" ng-repeat="stats in vm.c.statsMenus track by $index" ng-attr-id="{{stats.btnId}}" ng-click="vm.f.showDate(stats, $index, $event)" ng-class="{\'current\': stats.selected}"><a href="javascript:;" ng-bind="stats.title" ng-class="{\'c\': stats.curSelected}"></a> <span class="arrow"></span> <input class="layui-input" ng-attr-id="{{stats.dateId}}"></div><div class="sr-week-date" ng-show="vm.c.showWeekDate"><date-week max="vm.c.currentDate" week-range="vm.c.weekRange" on-change="vm.f.weekChange($event)" ng-click="$event.stopPropagation()"></date-week></div></div></div><div class="sr-stats-right"><span>时间：</span> <span ng-bind="vm.d.curDate">2017-11-25</span> <span>&nbsp;&nbsp;(太平洋时间，更新周期：北京时间每天09：00前)</span></div></div><div class="sr-industry util-clearfix"><span class="title">行业：</span><div class="items"><span class="item">All</span></div></div></div><div class="sr-bottom-wrap"><div class="sr-block-item"><div class="header"><h3 class="title">询盘流量概览</h3></div><div class="sr-indicator-items"><ul><li ng-repeat="item in vm.c.inqFlowMenus track by $index" ng-class="{\'bd-l\': $index !== 0}"><span class="name" ng-bind="item.name"></span> <span class="value" ng-bind="item.value"></span> <span class="compare"><span class="compare-type" ng-bind="vm.d.compareType" ng-hide="$index === vm.c.inqFlowMenus.length - 1"></span> <span class="compare-type" ng-show="$index === vm.c.inqFlowMenus.length - 1 && !vm.c.statsMenus[2].curSelected">较上周同期：</span> <span class="compare-type" ng-show="$index === vm.c.inqFlowMenus.length - 1 && vm.c.statsMenus[2].curSelected">较上月同期：</span> <span class="compare-value" ng-bind="item.compareValue" ng-class="{\'down\': item.compareValue.indexOf(\'-\') !== -1, \'up\': item.compareValue.indexOf(\'+\') !== -1}"></span></span> <span class="arrow-down"></span></li></ul></div></div><div class="sr-ta"><div class="sr-ta-diagnose"><span class="diagnose-title">询盘流量分析：</span> <span class="diagnose-info diagnose-info-high" ng-show="vm.c.inqInfoStatus === \'high\'"><span>您的询盘数据</span> <span class="em">高于</span> <span>同行平均水平，建议立即使用信用保障服务完成交易，持续领先！</span></span> <span class="diagnose-info diagnose-info-low" ng-show="vm.c.inqInfoStatus !== \'high\'"><span>您的询盘数据</span> <span class="em">低于</span> <span>同行平均水平，建议立即使用信用保障服务完成交易，提升效果！</span></span> <span class="detail-hideup-expand"><div class="hideup" ng-show="vm.c.lookInqData" ng-click="vm.c.lookInqData = false"><span class="hideup-info">收起</span> <i class="iconfont icon-less"></i></div><div class="expand" ng-show="!vm.c.lookInqData" ng-click="vm.f.viewInqData()"><span class="expand-info">查看数据详情</span> <i class="iconfont icon-moreunfold"></i></div></span></div><div class="sr-ta-detail" ng-show="vm.c.lookInqData"><div class="sr-ta-items"><div class="detail-item item-left"><div class="detail-chart"><h3><span class="title" ng-show="vm.d.curInq === \'exposure\'"><span>最近60天使用信用保障服务完成交易后，有</span> <span ng-bind="vm.c.inqViewInfo[0].supplier">68.2</span> <span>%的供应商曝光数据明显增长</span></span> <span class="title" ng-show="vm.d.curInq !== \'exposure\'"><span>最近60天使用信用保障服务完成交易后，有</span> <span ng-bind="vm.c.inqViewInfo[1].supplier">38.2%</span> <span>%的供应商反馈数据明显增长</span></span></h3><div class="charts-container"><i class="iconfont icon-back i-prev" ng-click="vm.f.toggleInqView()"></i> <i class="iconfont icon-more i-next" ng-click="vm.f.toggleInqView()"></i><div id="chart-container-orderImps" ng-show="vm.d.curInq === \'exposure\'" class="chart-container chart-container-orderImps"></div><div id="chart-container-orderFb" ng-show="vm.d.curInq !== \'exposure\'" class="chart-container chart-container-orderFb"></div><div class="dots"><span class="dot-item" ng-click="vm.f.toggleInqView(\'exposure\')"><span class="dot" ng-class="{\'dot-current\': vm.d.curInq === \'exposure\'}"></span> <span class="name">曝光</span></span> <span class="dot-item" ng-click="vm.f.toggleInqView(\'fb\')"><span class="dot" ng-class="{\'dot-current\': vm.d.curInq !== \'exposure\'}"></span> <span class="name">反馈</span></span></div></div></div></div><div class="detail-item item-right"><div class="detail-go"><div class="status"><span>您的店铺最近</span> <em>60</em> <span>天使用信用保障服务完成交易为</span> <em>0</em> <span>，立即行动吧。</span></div><a href="draft-trusts.html" target="_blank" class="util-btn util-btn-primary">起草信用保障订单</a> <a href="oms.html" target="_blank" class="util-btn util-btn-normal">查看买家发起订单</a></div></div></div></div></div><div class="sr-block-item"><div class="header"><h3 class="title">外贸直通车概览</h3><a href="marketing.html" target="_blank">营销中心&gt;</a></div><div class="sr-indicator-items"><ul><li ng-repeat="item in vm.c.tradeTrainMenus track by $index" ng-class="{\'bd-l\': $index !== 0}"><span class="name" ng-bind="item.name"></span> <span class="value" ng-bind="item.value"></span> <span class="compare"><span class="compare-type" ng-bind="vm.d.compareType"></span> <span class="compare-value" ng-bind="item.compareValue" ng-class="{\'down\': item.compareValue.indexOf(\'-\') !== -1, \'up\': item.compareValue.indexOf(\'+\') !== -1}"></span></span> <span class="arrow-down"></span></li></ul></div></div></div></div><div class="sr-module-wrapper"><div class="sr-top-wrap condition"><span class="sr-prev-day" ng-class="{\'last\': vm.d.rfqBtn.prev}" ng-click="vm.f.requestRfqData(\'prev\')">&lt;前一天</span> <span class="sr-current-day" ng-bind="vm.d.rfqCurDate"></span> <span class="sr-next-day" ng-class="{\'last\': vm.d.rfqBtn.next}" ng-click="vm.f.requestRfqData(\'next\')">后一天&gt;</span></div><div class="sr-bottom-wrap"><div class="sr-block-item"><div class="header"><h3 class="title">RFQ概览</h3><a href="rfq-index.html" target="_blank">去报价&gt;</a></div><div class="sr-indicator-items"><ul><li ng-repeat="item in vm.c.RFQMenus track by $index" ng-class="{\'bd-l\': $index !== 0}"><span class="name" ng-bind="item.name"></span> <span class="value" ng-bind="item.value"></span> <span class="compare"><span class="compare-type" ng-show="$index === 0">较上周同期：</span> <span class="compare-type" ng-show="$index === 1">较上月同期：</span> <span class="compare-value" ng-bind="item.compareValue" ng-class="{\'down\': item.compareValue.indexOf(\'-\') !== -1, \'up\': item.compareValue.indexOf(\'+\') !== -1}"></span></span> <span class="arrow-down"></span></li></ul></div></div><div class="sr-block-item"><div class="header"><h3 class="title">订单概览</h3><a href="oms.html" target="_blank">我的订单&gt;</a></div><div class="sr-indicator-items"><ul><li ng-repeat="item in vm.c.orderMenus track by $index" ng-class="{\'bd-l\': $index !== 0}"><span class="name" ng-bind="item.name" ng-class="{\'f-w700\': $index === 3}"></span> <span class="value" ng-bind="item.value"></span> <span class="compare"><span class="compare-type" ng-hide="$index === 3">较上月同期：</span> <span class="compare-type" ng-show="$index === 3">较上周同期：</span> <span class="compare-value" ng-bind="item.compareValue" ng-class="{\'down\': item.compareValue.indexOf(\'-\') !== -1, \'up\': item.compareValue.indexOf(\'+\') !== -1}"></span></span> <span class="arrow-down"></span></li></ul></div></div></div></div><div class="sr-block-product"><div class="header bg-white util-clearfix"><div class="header-main util-left"><h3 class="title">产品概览</h3><span class="current" ng-bind="vm.d.fixCurDate"></span></div><a href="javascript:;">我的产品&gt;</a></div><div class="sr-product-detail util-clearfix"><div class="j-prod-pie" id="j-prod-pie-1"></div><div class="j-prod-tab"><div class="product-tab-switches"><div class="product-tab-switch" ng-repeat="prod in vm.c.prodMenus track by $index" ng-class="{\'product-tab-switch-active\': prod.selected}" ng-click="vm.f.toggleProdTab(vm.c.prodMenus, $index)" ng-bind="prod.title"></div></div><div class="product-tab-content product-tab-effective" ng-show="vm.c.prodMenus[0].selected"><table class="product-tab-table"><thead class="product-tab-head"><tr><th class="product-cell-name">产品</th><th class="product-cell-owner">负责人</th><th class="product-cell-fb">反馈量</th><th class="product-cell-fb-percent">反馈占比</th></tr></thead><tbody><tr class="product-tab-row" ng-repeat="prod in vm.c.prods"><td class="product-cell-name"><span class="product-cell-number" ng-bind="prod.sort"></span> <img ng-src="{{prod.img}}"> <a class="util-ellipsis" ng-href="{{prod.href}}" ng-bind="prod.prodName"></a></td><td class="product-cell-owner" ng-bind="prod.owner"></td><td class="product-cell-fb" ng-bind="prod.fb"></td><td class="product-cell-fb-percent" ng-bind="prod.fbPercent"></td></tr></tbody></table></div><div id="j-prod-pie-2" class="product-tab-content sr-chart-wrap" ng-show="vm.c.prodMenus[1].selected"></div></div></div></div></div>',
            bindings: {},
            controllerAs: 'vm',
            controller: SelfResultCtrl
        })

    function SelfResultCtrl($filter, request, $q, $timeout, $scope, prodOverviewConfig, noResultProdConfig, inqExposureConfig, inqFbConfig) {

        var vm = this;

        vm.c = {
            statsMenus: [ // 统计菜单
                {
                    title: '按天统计',
                    btnId: 'day-btn',
                    dateId: 'date-day',
                    type: 'date',
                    min: '2017-8-30',
                    max: '2017-11-29',
                    lang: 'en',
                    oldValue: '2017-11-28'
                },
                {
                    title: '按周统计',
                    btnId: 'week-btn',
                    dateId: 'date-week',
                    type: 'week',
                    min: '2017-8-30',
                    max: '2017-11-29',
                    lang: 'en'
                },
                {
                    title: '按月统计',
                    btnId: 'month-btn',
                    dateId: 'date-month',
                    type: 'month',
                    min: '2017-8-1',
                    max: '2017-10-31',
                    lang: 'cn',
                    oldValue: '2017-10'
                }
            ],
            inqFlowMenus: [ // 询盘流量概览
                {
                    name: '曝光',
                    value: '1947',
                    // compareType: 'day',
                    compareValue: '-47.5%'
                },
                {
                    name: '点击',
                    value: '13',
                    compareValue: '+160.5%'
                },
                {
                    name: '点击率',
                    value: '0.67%',
                    compareValue: '+415.5%'
                },
                {
                    name: '访客',
                    value: '10',
                    compareValue: '+160.5%'
                },
                {
                    name: '反馈',
                    value: '1',
                    compareValue: '+147.5%'
                },
                {
                    name: '及时回复率',
                    value: '85.7%',
                    compareValue: '-8.5%'
                }
            ],
            inqInfoStatus: 'low', // 询盘流量状态
            lookInqData: false, // 是否查看询盘数据详情
            tradeTrainMenus: [ // 外贸直通车概览
                {
                    name: '外贸直通车的行业平均点击率',
                    value: '0.66%',
                    // compareType: 'day',
                    compareValue: '+4.7'
                },
                {
                    name: '外贸直通车曝光',
                    value: '1652',
                    // compareType: 'day',
                    compareValue: '-49.0%'
                },
                {
                    name: '外贸直通车点击',
                    value: '5',
                    // compareType: 'day',
                    compareValue: '0.0%'
                }
            ],
            RFQMenus: [ // RFQ概览
                {
                    name: '行业可报价RFQ量',
                    value: '4441',
                    // compareType: 'day',
                    compareValue: '-10.3%'
                },
                {
                    name: '本月审核通过的报价量',
                    value: '32',
                    // compareType: 'day',
                    compareValue: '+14.2%'
                }
            ],
            orderMenus: [ // 订单概览
                {
                    name: '提交信保订单数(近180天)',
                    value: '2',
                    // compareType: 'day',
                    compareValue: '0.0%'
                },
                {
                    name: '双方确认信保订单数(近180天)',
                    value: '0',
                    // compareType: 'day',
                    compareValue: '0.0%'
                },
                {
                    name: '已付款信保订单数(近180天)',
                    value: '0',
                    // compareType: 'day',
                    compareValue: '0.0%'
                },
                {
                    name: '信保订单完成率',
                    value: '0.0%',
                    // compareType: 'day',
                    compareValue: '0.0%'
                },
                {
                    name: '已发货信保订单数(近180天)',
                    value: '0',
                    // compareType: 'day',
                    compareValue: '0.0%'
                }
            ],
            prodMenus: [ // 产品菜单
                {
                    title: '近15天有效果产品',
                    name: '15day',
                    selected: true
                },
                {
                    title: '零效果产品',
                    name: 'noResult',
                    selected: false
                }
            ],
            prods: [ // 产品列表
                {
                    sort: 1,
                    img: 'images/data-admin/s1.jpg',
                    prodName: '80 SMD 360 degree high magnetic revolving flash / intermittent flashing beacon',
                    href: '',
                    owner: 'Gina yan', // 负责人
                    fb: 2, // 反馈量
                    fbPercent: '28.57%' // 反馈占比
                },
                {
                    sort: 2,
                    img: 'images/data-admin/s2.jpg',
                    prodName: 'High magnetic mount flashing beacon 12volt strobe lights',
                    href: '',
                    owner: 'Chris xiao', // 负责人
                    fb: 1, // 反馈量
                    fbPercent: '14.29%' // 反馈占比
                },
                {
                    sort: 3,
                    img: 'images/data-admin/s3.jpg',
                    prodName: '3 Watt 3 LED strobe lights bicycle',
                    href: '',
                    owner: 'Caroline zheng', // 负责人
                    fb: 1, // 反馈量
                    fbPercent: '14.29%' // 反馈占比
                },
                {
                    sort: 4,
                    img: 'images/data-admin/s4.jpg',
                    prodName: '360-Degree Amber LED Beacon/Pole mount/8Watt,60 leds',
                    href: '',
                    owner: 'Pamela Peng', // 负责人
                    fb: 1, // 反馈量
                    fbPercent: '14.29%' // 反馈占比
                },
                {
                    sort: 5,
                    img: 'images/data-admin/s5.jpg',
                    prodName: 'CE R65 1800mm Long Amber LED Warning Strobe Lightbar for Ambulance Police Truck',
                    href: '',
                    owner: 'Chris xiao', // 负责人
                    fb: 1, // 反馈量
                    fbPercent: '14.29%' // 反馈占比
                }
            ],
            inqViewInfo: [ // 询盘流量数据
                {
                    name: 'exposure', // 曝光
                    supplier: '68.2%',
                    selected: true
                },
                {
                    name: 'fb', // 反馈
                    supplier: '61.1%',
                    selected: false
                }
            ],
            currentDate: '', // 当前日期
            showWeekDate: false, //
            weekRange: {}
        };

        vm.d = {
            curInq: 'exposure', // 当前询盘
            curDate: '', // 当前询盘、直通车时间段
            rfqCurDate: '', // rfq数据时间
            fixCurDate: '', // 当前时间 不改变
            compareType: '', // 比较类型
            rfqBtn: { // rfq 前一天 后一天 是否到底
                prev: false,
                next: true
            }
        }

        vm.f = {
            toggleProdTab: toggleProdTab,
            viewInqData: viewInqData,
            toggleInqView: toggleInqView,
            showDate: showDate,
            weekChange: weekChange,
            requestRfqData: requestRfqData
        }

        var store = {
            monthPlugin: {
                lastChange: {
                    year: NaN,
                    month: NaN,
                },
            },
        };
        var prodOverviewChart; // 产品概览效果图
        var prodNoResultChart; // 零效果产品图
        var orderImpsChart; // 询盘曝光图
        var orderFbChart; // 询盘反馈图
        var DAY_TIMES_TAMP = 24 * 3.6e3 * 1e3;
        var DAY_FLAG = '0123456';
        var curDateTime = new Date(DSSX.util.getServerCurrentTime().getTime() - DAY_TIMES_TAMP * 2); // 当前时间
        var NUM_DAY = 91; // 几天的数据
        var MONTH_MS = 30 * 24 * 60 * 60 * 1000;
        var weekRangeAttrs = [];
        var validMonthRange = {
            min: '',
            max: new Date(DSSX.util.getServerCurrentTime().getFullYear() + '-' + (DSSX.util.getServerCurrentTime().getMonth() + 1) + '-01' + ' 00:00:00').getTime() - 1000
        };

        $scope.$watch('vm.c.weekRange', function (newVal) {
            vm.c.weekRange = newVal;
            weekRangeAttrs = [];
            for (var attr in vm.c.weekRange) {
                weekRangeAttrs.unshift(attr);
                validMonthRange.min = new Date(attr + '-01 00:00:00').getTime();
            }
        })

        init();

        function init() {
            console.log('[SelfResultCtrl init: ]');
            loadInqTrainDate(0, 'day').then(function () {
                toggleTabStatus(vm.c.statsMenus, 0, 'curSelected');
            });
            loadRfqOrderData(0);
            $timeout(function () {
                initVM();
                vm.c.currentDate = curDateTime;
            })
        }

        function initVM() {
            orderImpsChart = echartsV3.init($('#chart-container-orderImps')[0]);
            orderFbChart = echartsV3.init($('#chart-container-orderFb')[0]);
            prodOverviewChart = echartsV3.init($('#j-prod-pie-1')[0]);
            prodOverviewChart.setOption(prodOverviewConfig);

            //设置日历最大值为当前时间
            var max = curDateTime.getTime();
            var min = max - DAY_TIMES_TAMP * NUM_DAY;
            var minDate = $filter('date')(new Date(min), 'yyyy-MM-dd'); // 当前年月日
            var maxDate = $filter('date')(new Date(max), 'yyyy-MM-dd'); // 当前年月日

            for (var i = 0; i < vm.c.statsMenus.length; i++) {
                if (vm.c.statsMenus[i].type !== 'month') {
                    vm.c.statsMenus[i].min = minDate;
                    vm.c.statsMenus[i].max = maxDate;
                    vm.c.statsMenus[i].oldValue = $filter('date')(curDateTime, 'yyyy-MM-dd');
                } else {
                    var minYM = minDate.slice(0, -3);
                    var minD = minYM + '-01';
                    var maxYear = new Date(max).getFullYear();
                    var maxMonth = new Date(max).getMonth();
                    var maxD = maxYear + '-' + maxMonth + '-28';

                    vm.c.statsMenus[i].min = minD;
                    vm.c.statsMenus[i].max = maxD;
                    vm.c.statsMenus[i].oldValue = maxYear + '-' + maxMonth;
                }
            }

            // 设置当前所选时间段
            vm.d.curDate = $filter('date')(new Date(max), 'yyyy-MM-dd');
            vm.d.fixCurDate = $filter('date')(new Date(max), 'yyyy-MM-dd');
            vm.d.rfqCurDate = $filter('date')(new Date(max), 'yyyy-MM-dd');
        }

        // 切换tab状态
        function toggleTabStatus(tab, index, arg_attrName) {
            arg_attrName = arg_attrName || 'selected';
            resetTabStatus(tab);
            tab[index][arg_attrName] = true;
        }

        function resetTabStatus(tab, attrName) {

            attrName = attrName || 'selected';

            for (var i = 0; i < tab.length; i++) {
                tab[i][attrName] = false;
            }
        }

        // 切换产品效果tab
        function toggleProdTab(tab, index) {
            toggleTabStatus(tab, index);

            if (tab[index].name === 'noResult') {
                $timeout(function () {
                    prodNoResultChart = echartsV3.init($('#j-prod-pie-2')[0]);
                    prodNoResultChart.setOption(noResultProdConfig);
                })
            }

        }

        // 查看询盘分析数据
        function viewInqData() {

            vm.c.lookInqData = true;
            $timeout(function () {
                // orderImpsChart = echarts.init($('#chart-container-orderImps')[0]);
                orderImpsChart.setOption(inqExposureConfig);
            })
        }

        // 切换询盘曝光与反馈数据柱状图
        function toggleInqView(type) {

            if (type) {
                vm.d.curInq = type;
            } else {
                vm.d.curInq = vm.d.curInq === 'exposure' ? 'fb' : 'exposure';
            }

            if (vm.d.curInq === 'fb') {
                // orderFbChart = echarts.init($('#chart-container-orderFb')[0]);
                orderFbChart.setOption(inqFbConfig);
            } else {
                // orderImpsChart = echarts.init($('#chart-container-orderImps')[0]);
                orderImpsChart.setOption(inqExposureConfig);
            }
        }

        // 显示日期
        function showDate(stats, index, e) {
            toggleTabStatus(vm.c.statsMenus, index);

            if (stats.type === 'week') {
                e.stopPropagation();
                removeLayDate();
                vm.c.showWeekDate = true;
                return;
            }

            $timeout(function () {
                vm.c.showWeekDate = false;
                var selector = '#' + stats.dateId;
                $(selector).val(stats.oldValue);
                laydate.render({
                    elem: selector,
                    theme: 'b',
                    type: stats.type,
                    lang: stats.lang,
                    // value: stats.oldValue,
                    show: true, //直接显示
                    showBottom: false,
                    min: stats.min,
                    max: stats.max,
                    closeStop: '#' + stats.btnId, //这里代表的意思是：点击 test1 所在元素阻止关闭事件冒泡。如果不设定，则无法弹出控件
                    ready: function (value, date) { // 控件打开的时候触发

                    },
                    change: function (value, date, endDate) { // 切换年月的时候触发 要判断是日期选择器还是年月选择器触发 日期 value='2017-08-09' 年月 value='2017-08'

                        if (value.length > 7) {
                            return;
                        }

                        /**
                         * 这里由于点击两边的按钮切换年月时，
                         * 如果时间在合理范围内会直接请求数据，
                         * 然后关闭日历插件，
                         * 所以点击左右两边的按钮时直接return，
                         * 点击具体的年月时请求数据，
                         * 根据判断 上次变化月份 === 点击的月份 上次变化的年份 !== 点击的年份
                         * 来区别是点击具体的年月还是点击两边的按钮来触发的事件
                         */
                        var preLastChange = store.monthPlugin.lastChange;

                        store.monthPlugin.lastChange = {
                            year: date.year,
                            month: date.month,
                        };

                        if (preLastChange.month === date.month) {
                            if (preLastChange.year !== date.year) {
                                return;
                            }
                        }

                        var curTime = new Date(value).getTime();
                        if (curTime < validMonthRange.min || curTime > validMonthRange.max) {
                            return;
                        }

                        var selected;
                        switch (value) {
                            case weekRangeAttrs[0]:
                                selected = 3;
                                break;
                            case weekRangeAttrs[1]:
                                selected = 2;
                                break;
                            case weekRangeAttrs[2]:
                                selected = 1;
                                break;
                            default:
                                selected = 1;
                        }

                        loadInqTrainDate(selected, 'month').then(function () {
                            resetTabStatus(vm.c.statsMenus, 'curSelected');
                            toggleTabStatus(vm.c.statsMenus, 2, 'curSelected');
                            removeLayDate();
                            vm.d.curDate = value;
                            vm.c.statsMenus[2].oldValue = value;
                        });
                    },
                    done: function (value, date, endDate) { // 日期选择完毕触发
                        $timeout(function () {
                            var curTime = new Date(curDateTime.getTime());
                            var selectedTime = new Date(value);
                            var selected = Math.floor(((curTime - selectedTime) / DAY_TIMES_TAMP) % 7);
                            var type = stats.type === 'date' ? 'day' : 'month';

                            loadInqTrainDate(selected, type).then(function () {
                                resetTabStatus(vm.c.statsMenus, 'curSelected');
                                toggleTabStatus(vm.c.statsMenus, 0, 'curSelected');
                                vm.d.curDate = value;
                                vm.c.statsMenus[0].oldValue = value;
                            });
                        })
                    }
                });
            })
        }

        /**
         * 周日历变化事件
         * @param weekRange {start,end}
         */
        function weekChange(weekRange) {
            var curTime = new Date(curDateTime.getTime());
            var curDay = DAY_FLAG.charAt(curTime.getDay()); // 获得当前时间为周几
            var dateEnd = curTime - DAY_TIMES_TAMP * (+curDay + 1);
            var selected = (((dateEnd - (new Date(weekRange.end))) / (DAY_TIMES_TAMP * 7)) % 4) + 1;
            loadInqTrainDate(selected, 'week').then(function () {

                var start = $filter('date')(new Date(weekRange.start), 'yyyy-MM-dd');
                var end = $filter('date')(new Date(weekRange.end), 'yyyy-MM-dd');
                vm.d.curDate = start + ' 至 ' + end;
                // 关闭周日历
                vm.c.showWeekDate = false;
                resetTabStatus(vm.c.statsMenus, 'curSelected');
                toggleTabStatus(vm.c.statsMenus, 1, 'curSelected');
            });
        }

        // 点击空白处关闭 周日历 及tab状态
        $(document).click(function () {
            $timeout(function () {
                var laydateEle = $('.laydate-theme-b');
                if (!laydateEle.length) {
                    resetTabStatus(vm.c.statsMenus);
                }
                vm.c.showWeekDate = false;
            })
        })

        // 移除laydate
        function removeLayDate() {
            // 如果存在 laydate 则remove
            var laydateEle = $('.laydate-theme-b');
            if (laydateEle.length) {
                for (var i = 0; i < laydateEle.length; i++) {
                    laydateEle[i].remove();
                }
            }
        }

        // request rfq data
        function requestRfqData(option) {
            var fixDateTime = new Date(vm.d.fixCurDate).getTime();
            var curDateTime = new Date(vm.d.rfqCurDate).getTime();
            var aimsTime = option === 'prev' ? (curDateTime - DAY_TIMES_TAMP) : (curDateTime + DAY_TIMES_TAMP);
            var rs = Math.floor((fixDateTime - aimsTime) / DAY_TIMES_TAMP);
            var selected = rs % 7;

            if (selected < 0) {
                setRFQbtn(false, true);
                return;
            }

            if (rs > 30) {
                setRFQbtn(true, false);
                return;
            }
            setRFQbtn(false, false);
            loadRfqOrderData(selected).then(function () {
                vm.d.rfqCurDate = $filter('date')(new Date(aimsTime), 'yyyy-MM-dd');
            }).finally(function () {
                if (rs - 1 < 0) {
                    setRFQbtn(false, true);
                    return;
                }
                if (rs + 1 > 30) {
                    setRFQbtn(true, false);
                    return;
                }
                setRFQbtn(false, false);
            });
        }

        function setRFQbtn(prev, next) {
            vm.d.rfqBtn.prev = prev;
            vm.d.rfqBtn.next = next;
        }

        // 加载rfq,order数据
        function loadRfqOrderData(selected) {

            var params = {
                indicatorGroup: 'rfq,order',
                selected: selected,
                statisticsType: 'day'
            };

            return requestMyBriefData(params).then(callback, errCallback);

            function callback(res) {
                var value = res.data.value || {};
                // rfq
                var rfqIndustry = value.rfqIndustry || {};
                var rfqPass = value.rfqPass || {};
                vm.c.RFQMenus[0].value = $filter('currency')(rfqIndustry.value).slice(1).slice(0, -3);
                vm.c.RFQMenus[0].compareValue = addSymbol(rfqIndustry.wowDiff) || '-9.3%';
                vm.c.RFQMenus[1].value = $filter('currency')(rfqPass.value).slice(1).slice(0, -3);
                vm.c.RFQMenus[1].compareValue = addSymbol(rfqPass.momDiff) || '+17.2%';

                // order
                var taSubmit = value.taSubmit || {};
                var taConfirm = value.taConfirm || {};
                var taPay = value.taPay || {};
                var taPayRate = value.taPayRate || {};
                var taShipping = value.taShipping || {};

                vm.c.orderMenus[0].value = $filter('currency')(taSubmit.value).slice(1).slice(0, -3);
                vm.c.orderMenus[0].compareValue = addSymbol(taSubmit.momDiff) || '0.0%';
                vm.c.orderMenus[1].value = $filter('currency')(taConfirm.value).slice(1).slice(0, -3);
                vm.c.orderMenus[1].compareValue = addSymbol(taConfirm.momDiff) || '0.0%';
                vm.c.orderMenus[2].value = $filter('currency')(taPay.value).slice(1).slice(0, -3);
                vm.c.orderMenus[2].compareValue = addSymbol(taPay.momDiff) || '0.0%';
                vm.c.orderMenus[3].value = taPayRate.value + '%';
                vm.c.orderMenus[3].compareValue = addSymbol(taPayRate.momDiff) || '0.0%';
                vm.c.orderMenus[4].value = $filter('currency')(taShipping.value).slice(1).slice(0, -3);
                vm.c.orderMenus[4].compareValue = addSymbol(taShipping.momDiff) || '0.0%';
            }

            function errCallback(error) {
                DSSX.dialog.err(error, {
                    moduleName: '知己-我的效果',
                    funcName: 'loadRfqOrderData',
                    text: '加载RFQ、Order信息失败'
                });
                return $q.reject(error);
            }
        }

        // 加载inq,train数据
        function loadInqTrainDate(selected, type) {
            var params = {
                indicatorGroup: 'basic,p4p',
                selected: selected,
                statisticsType: type
            };

            return requestMyBriefData(params).then(callback, errCallback);

            function callback(res) {

                var data = res.data.value || {};

                var imps = data.imps || {};
                var clk = data.clk || {};
                var clkRate = data.clkRate || {};
                var visitor = data.visitor || {};
                var fb = data.fb || {};
                var reply = data.reply || {};

                var clkP4pIndustry = data.clkP4pIndustry || {};
                var impsP4p = data.impsP4p || {};
                var clkP4p = data.clkP4p || {};

                var attrDiff = type === 'month' ? 'momDiff' : 'wowDiff';

                vm.c.inqFlowMenus[0].value = $filter('currency')(imps.value).slice(1).slice(0, -3);
                vm.c.inqFlowMenus[0].compareValue = addSymbol(imps[attrDiff]) || '0.0%';
                vm.c.inqFlowMenus[1].value = $filter('currency')(clk.value).slice(1).slice(0, -3);
                vm.c.inqFlowMenus[1].compareValue = addSymbol(clk[attrDiff]) || '0.0%';
                vm.c.inqFlowMenus[2].value = clkRate.value + '%';
                vm.c.inqFlowMenus[2].compareValue = addSymbol(clkRate[attrDiff]) || '0.0%';
                vm.c.inqFlowMenus[3].value = $filter('currency')(visitor.value).slice(1).slice(0, -3);
                vm.c.inqFlowMenus[3].compareValue = addSymbol(visitor[attrDiff]) || '0.0%';
                vm.c.inqFlowMenus[4].value = $filter('currency')(fb.value).slice(1).slice(0, -3);
                vm.c.inqFlowMenus[4].compareValue = addSymbol(fb[attrDiff]) || '0.0%';
                vm.c.inqFlowMenus[5].value = reply.value + '%';
                vm.c.inqFlowMenus[5].compareValue = addSymbol(reply[attrDiff]) || '0.0%';

                vm.c.tradeTrainMenus[0].value = clkP4pIndustry.value + '%';
                vm.c.tradeTrainMenus[0].compareValue = addSymbol(clkP4pIndustry[attrDiff]) || '0.0%';
                vm.c.tradeTrainMenus[1].value = $filter('currency')(impsP4p.value).slice(1).slice(0, -3);
                vm.c.tradeTrainMenus[1].compareValue = addSymbol(impsP4p[attrDiff]) || '0.0%';
                vm.c.tradeTrainMenus[2].value = $filter('currency')(clkP4p.value).slice(1).slice(0, -3);
                vm.c.tradeTrainMenus[2].compareValue = addSymbol(clkP4p[attrDiff]) || '0.0%';

                vm.d.compareType = compareTime(type);

            }

            function errCallback(error) {
                DSSX.dialog.err(error, {
                    moduleName: '知己-我的效果',
                    funcName: 'loadInqTrainDate',
                    text: '加载询盘、外贸直通车信息失败'
                });
                return $q.reject(error);
            }

        }

        function requestMyBriefData(params) {
            return request.get('/pub/api/myBriefData', params, true);
        }

        function addSymbol(d) {
            if (+d === 0) {
                return '0.0%';
            }
            if (+d < 0) {
                return d + '%';
            }
            if (+d > 0) {
                return '+' + d + '%'
            }
        }

        // 根据时间类型返回对应的比较类型
        function compareTime(type) {
            var result = '';
            switch (type) {
                case 'day':
                    result = '较上周同期';
                    break;
                case 'week':
                    result = '较上周累计';
                    break;
                case 'month':
                    result = '较上月累计';
                    break;
            }
            return result;
        }

    }

})()